import React from "react";
import { useTranslation } from "react-i18next";
import { Settings } from "lucide-react";
import iconPie from "../../img/about/icon-pie.svg";
import iconResponsive from "../../img/about/icon-responsive.svg";

const CARDS = [
  {
    num: "01",
    titleKey: "about.platform.c1.title",
    descKey: "about.platform.c1.desc",
    cardBg: "bg-[#ffe6dc]",
    numColor: "text-[#ccc]",
    dotBg: "bg-[#f04e0a]",
    circleBg: "bg-[#ee5414]",
    titleColor: "text-[#0a0a0a]",
    descColor: "text-[#717171]",
    icon: <img src={iconPie} alt="" className="w-[24px] h-[24px]" />,
  },
  {
    num: "02",
    titleKey: "about.platform.c2.title",
    descKey: "about.platform.c2.desc",
    cardBg: "bg-[#0a0a0a]",
    numColor: "text-[#444]",
    dotBg: "bg-[#f04e0a]",
    circleBg: "bg-white",
    titleColor: "text-white",
    descColor: "text-[#717171]",
    icon: <img src={iconResponsive} alt="" className="w-[24px] h-[24px]" />,
  },
  {
    num: "03",
    titleKey: "about.platform.c3.title",
    descKey: "about.platform.c3.desc",
    cardBg: "bg-[#f04e0a]",
    numColor: "text-[#f7a684]",
    dotBg: "bg-white",
    circleBg: "bg-[#0a0a0a]",
    titleColor: "text-white",
    descColor: "text-[#fbd3c2]",
    icon: <Settings size={26} color="#fff" />,
  },
];

function Card({ num, titleKey, descKey, cardBg, numColor, dotBg, circleBg, titleColor, descColor, icon }) {
  const { t } = useTranslation();
  return (
    <div className={`${cardBg} rounded-[20px] pt-[30px] pl-[30px] pr-[28px] pb-[30px] xl:pb-[51px] min-h-[240px] xl:h-[319px] flex flex-col gap-[30px] xl:gap-[40px] flex-1`}>
      <div className="flex items-center justify-between">
        <span className={`font-['Montserrat'] font-bold text-[13px] ${numColor} tracking-[1.3px] leading-normal`}>{num}</span>
        <span className={`${dotBg} rounded-[7px] w-[14px] h-[14px]`} />
      </div>
      <div className="flex flex-col gap-[20px] xl:gap-[40px]">
        <div className={`${circleBg} rounded-full w-[52px] h-[52px] flex items-center justify-center shrink-0`}>
          {icon}
        </div>
        <div className="flex flex-col gap-[12px]">
          <h3 className={`font-['Montserrat'] font-black text-[18px] xl:text-[24px] ${titleColor} tracking-[-0.76px] uppercase leading-[1.3] xl:leading-[38px]`}>
            {t(titleKey)}
          </h3>
          <p className={`font-['Inter'] font-normal text-[14px] xl:text-[16px] ${descColor} leading-[1.4]`}>
            {t(descKey)}
          </p>
        </div>
      </div>
    </div>
  );
}

function Platform() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col gap-[40px] xl:gap-[60px]">

        {/* Header */}
        <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-[20px]">
          <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none xl:max-w-[504px]">
            {t("about.platform.title")}
          </h2>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4] xl:max-w-[600px]">
            {t("about.platform.desc")}
          </p>
        </div>

        {/* Cards */}
        <div className="flex flex-col xl:flex-row gap-[20px]">
          {CARDS.map((card) => (
            <Card key={card.num} {...card} />
          ))}
        </div>

      </div>
    </section>
  );
}

export default Platform;
